<template>
  <table class="do-table">
    <thead>
    <tr>
      <th></th>
      <th class="hide-title-th"
          :content='tooltipForHideTitle'
          v-tippy="{
                arrow: false,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window',
              }">{{ i18n['hide_title'] }} <span class="icon-question3"></span></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="reason in items" :key="reason.id">
      <td>{{ reason.name }}</td>
      <td class="hide-title-td">
        <div class="do-table-flex">
          <AppToggle :propOn="reason.default_private" @changed="$emit('editAbsencePrivate', reason)"></AppToggle>
        </div>
      </td>
      <td>
        <button class="do-bttn do-bttn--small" :class="{'do-bttn--loading': theUpdatingReasonId === reason.id}"
                @click="$emit('toggleArchived', reason)">{{
            reason.archived ? i18n['dearchive'] : i18n['archive']
          }}
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
import AppToggle from '../common/AppToggle.vue'

const I18N = {
  da: {
    absence_reasons: 'Fraværsårsager',
    create_absence: 'Opret fraværsårsag',
    need_a_title: 'Mangler et navn',
    title: 'Navn',
    hide_title: 'Skjul titel',
    archive: 'Arkivér',
    dearchive: 'Genskab',
    no_absence_reasons_created: 'Ingen fraværsårsager oprettet',
    tooltip_for_hide_title: 'Når "Skjul titel" er aktiveret, er fraværstitlen kun synlig for administratorer og brugeren med fraværet – for andre vises blot "Fravær". Hvis indstillingen deaktiveres, er titlen synlig for alle, også i Aula.',
    title_already_exists: 'Navnet findes i forvejen'
  },
  nb: {
    absence_reasons: 'Fraværsårsaker',
    create_absence: 'Opprett fraværsårsak',
    hide_title: 'Skjul tittel',
    archive: 'Arkiver',
    dearchive: 'Gjenopprett',
    title: 'Navn',
    need_a_title: 'Mangler et navn',
    no_absence_reasons_created: 'Ingen fraværsårsaker opprettet',
    tooltip_for_hide_title: 'Når "Skjul tittel" er aktivert, er fraværstittelen kun synlig for administratorer og brukeren fraværet gjelder – for andre vises bare "Fravær". Hvis innstillingen deaktiveres, blir tittelen synlig for alle.',
    title_already_exists: 'Navnet finnes allerede'
  },
  en: {
    absence_reasons: 'Absence reasons',
    create_absence: 'Create absence reason',
    hide_title: 'Hide title',
    archive: 'Archive',
    dearchive: 'Restore',
    title: 'Name',
    need_a_title: 'Missing a name',
    no_absence_reasons_created: 'No absence reasons created',
    tooltip_for_hide_title: 'When "Hide title" is enabled, the absence title is only visible to administrators and the user the absence relates to – others will simply see "Absence". If the setting is disabled, the title becomes visible to everyone.',
    title_already_exists: 'The name already exists'
  }
}
export default {
  components: {AppToggle},
  props: {
    items: {
      default: []
    },
    theUpdatingReasonId: {
      default: null
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale]
    },
    tooltipForHideTitle () {
      return this.i18n['tooltip_for_hide_title']
    }
  }
}
</script>

<style scoped>
.do-table tr {
  border-bottom: 1px solid #e3e8ee;
}

.do-table tr:hover {
  background-color: aliceblue;
}

.do-table tr td:first-child {
  font-weight: bold;
}

.do-table tr th:first-child,
.do-table tr td:first-child {
  width: 300px;
}

.do-table tr td:last-child {
  text-align: right;
}

.do-table-flex {
  display: flex;
  align-items: center;
}

.hide-title-td,
.hide-title-th {
  width: 100px;
}

.hide-title-th {
  cursor: help;
}

.do-bttn.do-bttn--small {
  font-size: 11px;
  height: auto;
  padding: 5px 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}


</style>



// WEBPACK FOOTER //
// AbsenceReasonsTable.vue?1274523b